import axios from "axios";
import { startOfQuarter,parse,format } from "date-fns";

const state = {
	admissions: [],
	admissionsParams: {},
	admission: {},
	admissionHistory: [],
	admissionsBySection: {},
};

function fixAdmissionDates(admission){
	var admission_date = admission.timestamp_creation;
	var discharge_date = admission.timestamp_archived;

	try {

		if(admission_date){

			admission_date += " +0000";
			var d = parse(admission_date, 'yyyy-MM-dd HH:mm XX', new Date());

			admission.timestamp_creation = format(d,"MM/dd/yyyy HH:mm")
		}

		if(discharge_date){

			discharge_date += " +0000";
			var d = parse(discharge_date, 'yyyy-MM-dd HH:mm XX', new Date());

			admission.timestamp_archived = format(d,"MM/dd/yyyy HH:mm")
		}
	}catch(error){

	}

	
}

function fixAdmissionDateField(admission,field){
	var date = admission[field];


	if(date){

		date += " +0000";
		var d = parse(date, 'yyyy-MM-dd HH:mm XX', new Date());

		admission[field] = format(d,"MM/dd/yyyy HH:mm")
	}

	
}

const actions = {

	updateAdmissionsParams(context,params){
		context.commit("setAdmissionsParams",params);
	},

	async loadAdmissions(context){

		if(Object.keys(state.admissionsParams).length===0){
			return;
		}

		return axios.get("/api/1/admissions", {
			params: state.admissionsParams
		}).then(function(response){
			context.commit("setAdmissions",response.data.result.admissions);
		});

	},

	async admissionUpdateEvent(context,event){
		var list_id = event.list_id;
		var admission = event.admission_id;

		if(context.state.admission.admission_id == admission&&window.location.href.indexOf("/admission/")>-1){
			actions.loadAdmission(context,admission)
			actions.loadAdmissionHistory(context,admission)
		} else if(context.rootState.list.currentList.list_id == list_id&&state.admissionsParams.list_id){
			// For sosop (uid 1), don't filter out updates since backend uses different user_ids (0 and 1)
			if(context.rootState.user.user.uid == 1) {
				// For sosop, allow all updates to show real-time changes
				actions.loadAdmissions(context)
			} else {
				// For other users, use original filtering behavior
				if(context.rootState.user.user.uid != event.user_id){
					actions.loadAdmissions(context)
				}
			}
		}
	},

	async admissionLabUpdateEvent(context,event){
		var list_id = event.list_id
		console.log("labupdate",list_id)
		if(context.rootState.list.currentList.list_id==list_id&&state.admissionsParams.list_id){
			context.commit('updateAdmissionLabs',event);
		}
	},


	async admissionArchiveEvent(context,event){
		var list_id = event.list_id;
		var admission = event.admission_id;
		var user_id = event.user_id;

		if(context.state.admission.admission_id == admission&&window.location.href.indexOf("/id/")>-1){
			actions.loadAdmission(context,admission)
		}
	},

	async admissionFieldUpdateEvent(context,event){
		var list_id = event.list_id;
		var admission = event.admission_id;

		var old_list_id = event.old_list_id;

		var user_id = event.user_id;

		// For sosop (uid 1), don't filter out updates since backend uses different user_ids (0 and 1)
		if(context.rootState.user.user.uid == 1) {
			// For sosop, allow all updates to show real-time changes
		} else {
			// For other users, use original filtering behavior
			if(context.rootState.user.user.uid==user_id){
				//in this case we made the change ourself so we will do nothing
				return;
			}
		}

		if(old_list_id&&
			(context.rootState.list.currentList.list_id == old_list_id||context.rootState.list.currentList.list_id == list_id)){
			actions.loadAdmissions(context)
		} else if(context.rootState.list.currentList.list_id == list_id&&state.admissionsParams.list_id){

			if(event.field=="admission_section"){
				context.dispatch("rankChangeEvent",event);
				return;
			}

			context.commit('updateAdmissionInList',event);
			
		}
		
		if(state.admission.admission_id == admission){
			context.commit('updateAdmission',event);
			actions.loadAdmissionHistory(context,admission)
		}
	},

	async admissionDeleteEvent(context,event){
		var list_id = event.list_id;
		var admission = event.admission_id;


		if(context.rootState.list.currentList.list_id == list_id&&context.state.admissionsParams.list_id){
			actions.loadAdmissions(context)
		}
		if(context.state.admission.admission_id == admission&&window.location.href.indexOf("/admission/")>-1){
			alert("This entry has been deleted.");

			var current_app = context.rootState.user.current_app;

			var location = "/#/list/";

			if(current_app=="board"){
				var location = "/#/board/";
			}else if(current_app=="card"){
				var location = "/#/list-open/";
			}

			window.location = location + list_id;
		}
	},

	async loadAdmission(context, admission_id){

		var params = {
				admission_id: admission_id,
                all: 1,
                
            }

		return axios.get("/api/1/admissions", {
			params: params
		}).then(function(response){
			var admissions = response.data.result.admissions
			if(admissions && admissions.length > 0){
				context.commit("setAdmission",admissions[0]);
			}
			
		});
	},

	async loadAdmissionHistory(context, admission_id){
		return axios.get("/api/1/admissions/"+admission_id+"/history").then(function(response){
			if(response.data.success){
				context.commit("setAdmissionHistory",response.data.result)
			}
			
		})
	},

	applyChangeToAdmissionsBySection(context, change){
		if(change.added){
			context.commit("addToSection",change)
		}else if(change.removed){
			context.commit("removeFromSection",change)
		}else if(change.moved){
			context.commit("moveAdmission",change)
		}
	},

}

const mutations = {
	setAdmissionsParams(state,params){
		state.admissionsParams = params;
	},
	setAdmissions(state,data){
		state.admissions = data;
		for(var i=0; i<state.admissions.length; i++){	
			fixAdmissionDates(state.admissions[i]);
		}

		state.admissionsBySection = {};
		for(var i=0; i<state.admissions.length; i++){
			var section = state.admissions[i].admission_section;
			if(state.admissionsBySection[section]){
				state.admissionsBySection[section].push(state.admissions[i])
			}else {
				state.admissionsBySection[section] = [state.admissions[i]];
			}
		}
	},
	setAdmission(state,data){



		fixAdmissionDates(data)


		if (data.ainc) {
            data.ainc = "1"
        }

		state.admission = data;
	},
	setAdmissionHistory(state,data){
		state.admissionHistory = data;
	},
	updateAdmissionInList(state,data){

		var admission_id = data.admission_id;
		var field = data.field;
		var value = data.value;

		var json_field = data.json_field;
		var json_value = data.json_value;

		for(var i=0; i<state.admissions.length; i++){

			if(state.admissions[i].admission_id == admission_id){
				state.admissions[i][field] = value

				if(json_field){
					state.admissions[i][json_field] = json_value;
				}
				
				if(field=='timestamp_creation'||field=='timestamp_archived'){
					fixAdmissionDateField(state.admissions[i],field)
				}
				

			}

		}

	},

	updateAdmissionLabs(state,data){
		console.log("UPDATING LABS")
		var admission_id = data.admission_id;
		var lab_1 = data.lab_1;
		var lab_2 = data.lab_2;

		for(var i=0; i<state.admissions.length; i++){

			if(state.admissions[i].admission_id == admission_id){
				state.admissions[i].lab_1 = lab_1;
				state.admissions[i].lab_2 = lab_2;
			}
		}
	},

	updateAdmission(state,data){

		var field = data.field;
		var value = data.value;

		var json_field = data.json_field;
		var json_value = data.json_value;

		state.admission[field] = value

		if(json_field){
			state.admission[json_field] = json_value;
		}

		if(field=='timestamp_creation'||field=='timestamp_archived'){
			fixAdmissionDateField(state.admission,field)
		}


	},

	addToSection(state,change){

		var array = state.admissionsBySection[change.section] || [];
		array.splice(change.added.newIndex,0,change.added.element);

		state.admissionsBySection[change.section] = array

	},

	removeFromSection(state,change){
		var array = state.admissionsBySection[change.section];
		array.splice(change.removed.oldIndex,1)

		state.admissionsBySection[change.section] = array;
	},

	moveAdmission(state,change){
		var array = state.admissionsBySection[change.section];
		array.splice(change.moved.oldIndex,1)
		array.splice(change.moved.newIndex,0,change.moved.element);

		state.admissionsBySection[change.section] = array;

	},

}

const getters = {
	admissions(state){
		return state.admissions;
	},
	admission(state){
		return state.admission;
	},
	admissionHistory(state){
		return state.admissionHistory
	},
	admissionsParams(state){
		return state.admissionsParams;
	},
	admissionsBySection(state){
		
		return state.admissionsBySection;
	},
	getSectionAdmissions(state,section){
		return state.admissionsBySection[section];
	},
};
  

export default {
    state,
    actions,
    mutations,
    getters
};